import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import { Hospital } from '../../../../shared/api/hscan/hospital';
import { BRAND_NAME } from '../../../../shared/env';
import { CheckboxWithText } from '../../common/components/CheckboxWithText';
import { HospitalAutocompleteSlot } from '../../common/components/Slot';
import { Spacer } from '../../common/components/Spacer';
import {
  SectionContentContainer,
  SectionHeading,
  TermText,
} from '../../common/components/styledComponents';

const InstitutionSlotWrapper = styled.div`
  width: 394px;
  max-width: 100%;
  margin-top: 20px;

  display: flex;
  flex-direction: column;
  row-gap: 26px;
  container-type: inline-size;
`;

interface SendImageSectionProps {
  hospital: Hospital | null;
  onChangeHospital: (hospital: Hospital | null) => void;
  checkTerm: boolean;
  setCheckTerm: (checked: boolean) => void;
  selectedHospitalIds?: string[];
}
export const SendImageSection = ({
  hospital,
  onChangeHospital,
  checkTerm,
  setCheckTerm,
  selectedHospitalIds,
}: SendImageSectionProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.request.storeReservation',
  });

  useEffect(() => {
    setCheckTerm(false);
  }, [hospital, setCheckTerm]);

  return (
    <SectionContentContainer>
      <SectionHeading>{t('heading')}</SectionHeading>
      <Spacer height="37px" />
      <TermText>{t('terms1', { brandName: BRAND_NAME })}</TermText>
      <InstitutionSlotWrapper>
        <HospitalAutocompleteSlot
          label={`${t('hospital')}:`}
          value={hospital}
          onChangeHospital={onChangeHospital}
          storeEnabledOnly
          exclusiveHospitalIds={selectedHospitalIds}
        />
      </InstitutionSlotWrapper>
      <Spacer height={21} />
      <CheckboxWithText
        text={<TermText>{t('terms2')}</TermText>}
        value={checkTerm}
        onChange={value => setCheckTerm(value)}
      />
    </SectionContentContainer>
  );
};
